import { observable, action } from 'mobx';
import { ViewBase } from 'mutants-appfx';
import _clonedeep from 'lodash/cloneDeep'

class SerialNumber extends ViewBase {

    constructor(store, name) {
        super(store, name);
    }

    @observable visible = false;
    @observable title;
    @observable head;
    @observable body;
    @observable cancelEnable
    output

    get type() { return 'SerialNumber' }

    @action init(initData) {
        initData = _clonedeep(initData)
        this.title = initData.title;
        this.head = initData.data.head;
        this.body = initData.data.body;
        this.cancelEnable = initData.cancelEnable;
        this.show();
        return new Promise((resolve, reject) => {
            this.output = resolve;
        })
    }

    @action show() {
        this.visible = true
    }

    @action hide() {
        this.visible = false
    }

    @action ok = () => {
        this.hide();
        this.output(this.body)
    }

    @action cancel = () => {
        this.hide();
        this.output();
    }

    @action changeValue(el, value) {
        el.Value = value
    }

    static fromJS(store) {
        return new SerialNumber(store, 'SerialNumber');
    }
}
export default SerialNumber;